import Swal from 'sweetalert2';

const toast = (icon, title, timer = 1500) =>
  Swal.fire({
    icon,
    title,
    timer,
    showConfirmButton: false,
    toast: true,
    position: 'top',
    timerProgressBar: true,
    customClass: { popup: 'text-sm' }
  });

export const success = (msg) => toast('success', msg);
export const error = (msg) => toast('error', msg);
export const warning = (msg) => toast('warning', msg);

export const confirm = (title, text = '', confirmText = 'ຢືນຢັນ') =>
  Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3E3F29',
    cancelButtonColor: '#7D8D86',
    confirmButtonText: confirmText,
    cancelButtonText: 'ຍົກເລີກ',
    borderRadius: '16px',
  });
